"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAFFIC_CONTROL_PATCH_NOTIFICATION_SETTINGS = exports.PATCH_NOTIFICATION_SETTINGS = exports.RECEIVE_NOTIFICATION = void 0;
exports.RECEIVE_NOTIFICATION = '@notifications/RECEIVE_NOTIFICATION';
exports.PATCH_NOTIFICATION_SETTINGS = '@notifications/PATCH_NOTIFICATION_SETTINGS';
exports.TRAFFIC_CONTROL_PATCH_NOTIFICATION_SETTINGS = '@traffic-control/PATCH_NOTIFICATION_SETTINGS';